import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// [AL-BARON_CORE_CONFIG] - إعدادات النواة لمنصة النور 2026
const firebaseConfig = {
  apiKey: "AIzaSyA--soZsAyl2qX7WIlkdAONQVlGxUWJXgs",
  
  // ✅ التعديل الذهبي: ربط التوثيق بالدومين الرسمي لضمان استقرار الدخول في Edge/Chrome
  authDomain: "alnoor-edu-iq.com", 
  
  projectId: "al-noor-academy-d6d00",
  storageBucket: "al-noor-academy-d6d00.firebasestorage.app",
  messagingSenderId: "1047481823021",
  appId: "1:1047481823021:web:ae25d209e257c14232ada4",
  measurementId: "G-X7P7WNZ20L"
};

// تشغيل Firebase الملكي
const app = initializeApp(firebaseConfig);

// تصدير خدمات المنصة للعمل في كافة الأقسام
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

/**
 * دالة بارونية لإرسال التنبيهات
 * @param {string} text - نص الإشعار
 * @param {string} role - منو يشوف الإشعار ('student' أو 'teacher')
 * @param {string} senderId - معرف المستخدم المرسل (عشان ما يرجع التنبيه للمرسل)
 * @param {string} type - نوع الإشعار ('video', 'chat', 'exam', etc)
 */
export const sendNotification = async (text, role, targetId, type = 'alert') => {
    try {
        await addDoc(collection(db, "notifications"), {
            text: text,
            role: role,
            targetId: targetId, // ✅ هذا هو المفتاح الباروني!
            createdAt: serverTimestamp(),
            type: type,
            isRead: false
        });
        console.log("تم إرسال التنبيه المخصص يا ضلع! 🛡️");
    } catch (error) {
        console.error("خطأ باروني:", error);
    }
};
export default app;